__turbopack_context__.v({
  "controls": "recipes-toolbar-module__KdYBNW__controls",
  "generate": "recipes-toolbar-module__KdYBNW__generate",
  "toolbar": "recipes-toolbar-module__KdYBNW__toolbar",
});
